import React from 'react';
import { Card, CardBody, Spinner } from 'reactstrap';
import { GoAlert } from "react-icons/go";

function ExitDetectionStatistics({ Camstatusdata, statsLoader,alertcount }) {
  console.log('Camstatusdata:', Camstatusdata);

  const statsData = [
    {
      label: "Total Detections",
      value: Camstatusdata?.total_logs,
      color: "",
    },
    {
      label: "Recognized",
       value: (Camstatusdata?.total_logs || 0) - (Camstatusdata?.total_violations || 0),
      color: "",
    },
    {
      label: "Unknown",
       value: Camstatusdata?.total_violations ,
      color: "#DC2626",
    },
    {
      label: "Blacklisted",
      value: Camstatusdata?.blacklisted || 0,
      color: "#DC2626",
    },
    {
      label: "Total SOP Followed",
      value: Camstatusdata?.sop_followed || 0,
      color: "#1D67AA",
    },
    {
      label: "Total SOP Un Followed",
      value: Camstatusdata?.sop_unfollowed || 0,
      color: "#DC2626",
    },
  ];

  return (
    <Card>
      <CardBody className='pb-0'>
        <h2 className='py-3' style={{ fontSize: "18px", fontWeight: "600", color: "#1D67AA" }}>
          Detection Statistics
        </h2>

        {statsLoader ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <Spinner color="success" style={{ width: '2.5rem', height: '2.5rem' }} />
          </div>
        ) : (
          statsData.map((stat, index) => (
            <div className="d-flex justify-content-between align-items-center py-3" key={index}>
              <h2 style={{ fontSize: "14px", fontWeight: "400", color: "#4B5563" }}>
                {stat.label}
              </h2>
              <h5 style={{ fontSize: "20px", fontWeight: "700", color: stat.color || "#000" }}>
                {stat.value}
              </h5>
            </div>
          ))
        )}
      </CardBody>
    </Card>
  );
}

export default ExitDetectionStatistics;
